import { render, staticRenderFns } from "./DragAndDropQuestion.vue?vue&type=template&id=5e10e106&scoped=true"
import script from "./DragAndDropQuestion.vue?vue&type=script&lang=js"
export * from "./DragAndDropQuestion.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropQuestion.vue?vue&type=style&index=0&id=5e10e106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10e106",
  null
  
)

export default component.exports